<ng-container *ngIf="settings$ | async as settings">
  <app-import-tools-sftp
    [bankAccount]="bankAccount"
    [settings]="settings"
  ></app-import-tools-sftp>
</ng-container>
